module.exports = __webpack_public_path__ + "media/images/choose/header-41f247c3261157ea03f65818689c4def.png";